// src/components/shared/Autocomplete.js
import React, { useState } from 'react';
import styled from 'styled-components';

const AutocompleteWrapper = styled.div`
  position: relative;
  width: 100%;
`;

const SuggestionsList = styled.ul`
  position: absolute;
  top: 100%;
  width: 100%;
  max-height: 200px;
  overflow-y: auto;
  background-color: ${(props) => props.theme.colors.surface};
  border: 1px solid ${(props) => props.theme.colors.inputGray};
  border-radius: 4px;
  z-index: 1000;
  list-style: none;
  margin: 0;
  padding: 0;
`;

const SuggestionItem = styled.li`
  padding: 10px;
  cursor: pointer;
  &:hover {
    background-color: ${(props) => props.theme.colors.background};
  }
`;

const InputWrapper = styled.div`
  position: relative;
  margin-bottom: ${(props) => props.theme.spacing(1)};

  svg {
    position: absolute;
    left: 16px;
    top: 50%;
    transform: translateY(-50%);
    font-size: 1.2rem;
    color: ${(props) => props.theme.colors.inputGray};
  }

  label {
    position: absolute;
    top: 5%;
    left: 45px;  /* Padding to align with the input's left padding */
    transform: translateY(-50%);
    background-color: ${(props) => props.theme.colors.surface};  /* Background color to overlap input's border */
    color: ${(props) => props.theme.colors.inputGray};
    font-size: 14px;
    transition: all 0.2s ease;
    padding: 0 5px;  /* Add some padding to prevent label from cutting off */
    pointer-events: none;  /* Prevents the label from being clicked */

  }

  input {
    width: 100%;
    padding: 25px;
    padding-left: 45px;  /* Leave space for the icon */
    margin: 5px 0;
    font-size: 1.2em;
    border: 1px solid ${(props) => props.theme.colors.inputGray};
    border-radius: 5px;
    background-color: ${(props) => props.theme.colors.surface};
    color: ${(props) => props.theme.colors.textPrimary};
    outline: none;

    &:focus {
      border-color: ${(props) => props.theme.colors.textPrimary};
    }

    &:focus + label,
    &:not(:placeholder-shown) + label {
      
      color: ${(props) => props.theme.colors.textPrimary};  /* Change label color when input is focused */
      font-size: 14px;
    }

    &::placeholder {
      color: ${(props) => props.theme.colors.inputGray};
    }
  }

  .error-message {
    color: ${(props) => props.theme.colors.error};
    font-size: 1.1em;
    margin-top: 5px;
  }
`;

const Autocomplete = ({ value, onChange, suggestions, onSelect, placeholder, onSearch, label, icon }) => {
  const [showSuggestions, setShowSuggestions] = useState(false);
  const [hasValue, setHasValue] = useState(false);
  
  const handleChange = (e) => {
    const newValue = e.target.value;
    onChange(newValue);
    setShowSuggestions(true);
    if (onSearch) {
      onSearch(newValue);
    }
  };

  const handleSelect = (suggestion) => {
    onSelect(suggestion);
    setShowSuggestions(false);
  };

  const handleBlur = () => {
    // Delay hiding suggestions to allow clicks to register
    setTimeout(() => setShowSuggestions(false), 200);
  };

  return (
    <AutocompleteWrapper>
        <InputWrapper>
        {icon}
        <input
            type="text"
            value={value}
            onChange={handleChange}
            placeholder={placeholder}
            onBlur={handleBlur}
        />
        <label className={hasValue ? 'active' : ''}>{label}</label>
      </InputWrapper>
      {showSuggestions && (
        <SuggestionsList>
          {suggestions && suggestions.length > 0 ? (
            suggestions.map((suggestion, index) => (
              <SuggestionItem key={index} onClick={() => handleSelect(suggestion)}>
                {suggestion.name}
              </SuggestionItem>
            ))

          ) : (
            <SuggestionItem></SuggestionItem>
          )}
          <SuggestionItem onClick={() => handleSelect('add_new_lead')}>
              <strong>Add New Lead</strong>
            </SuggestionItem>
        </SuggestionsList>
      )}
    </AutocompleteWrapper>
  );
};

export default Autocomplete;
